import { useEffect, useState } from "react"


export default function PromoPlan(props) {

    const handleTerminalPicked = () => {

        props.changeVal("terminal", props.name)

        props.nextStep();
    }


    return (
        <div className="p-4 xl:w-1/4 md:w-1/2 w-full">
            {props.popular === false &&
                <div className="h-full p-4 rounded-lg border-2 border-gray-300 flex flex-col relative overflow-hidden">
                    <h2 className="text-base tracking-wide title-font mb-1 font-medium">{props.name}</h2>
                    <h1 className="text-4xl text-gray-900 font-bold pb-4 mb-4 border-b border-gray-200 leading-none"><span className="line-through">{props.cost}</span><span className="no-line-through"> FREE</span></h1>
                    <img className="border-b border-gray-200" src={props.image} />
                    {props.features.map((feature) =>
                        <div className="flex items-center text-gray-600 mb-5">
                            {props.color ? (
                                <span style = {{backgroundColor: props.color}} className={`w-4 h-4 mr-2 inline-flex items-center justify-center text-white rounded-full flex-shrink-0`}>
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-3 h-3" viewBox="0 0 24 24">
                                        <path d="M20 6L9 17l-5-5"></path>
                                    </svg>
                                </span>
                            ) : (
                                <span className="w-4 h-4 mr-2 inline-flex items-center justify-center bg-primary-50 text-white rounded-full flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-3 h-3" viewBox="0 0 24 24">
                                        <path d="M20 6L9 17l-5-5"></path>
                                    </svg>
                                </span>
                            )}

                            <div className="text-xl">
                                {feature}
                            </div>

                        </div>
                    )}
                    <button onClick={handleTerminalPicked} className="flex items-center mt-auto text-white bg-gray-400 border-0 py-2 px-4 w-full focus:outline-none hover:bg-gray-500 rounded">{props.buttonTxt}
                        <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                            <path d="M5 12h14M12 5l7 7-7 7"></path>
                        </svg>
                    </button>
                    <div className="text-xs text-gray-500 mt-3">{props.bottomTxt}</div>
                </div>
            }
            {props.popular === true && props.color &&
                <div style = {{borderColor: props.color}} className={`h-full p-4 rounded-lg border-2 flex flex-col relative overflow-hidden`}>
                    <span style = {{backgroundColor: props.color}} className={`text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl`}>{props.card}</span>
                    <h2 className="text-base tracking-wide title-font mb-1 font-medium">{props.name}</h2>
                    <h1 className="text-4xl text-gray-900 font-bold pb-4 mb-4 border-b border-gray-200 leading-none"><span className="line-through">{props.cost}</span><span className="no-line-through"> FREE</span></h1>
                    <img className="border-b border-gray-200" src={props.image} />
                    {props.features.map((feature) =>
                        <div className="flex items-center text-gray-600 mb-5">
                            {props.color ? (
                                <span style = {{backgroundColor: props.color}} className={`w-4 h-4 mr-2 inline-flex items-center justify-center text-white rounded-full flex-shrink-0`}>
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-3 h-3" viewBox="0 0 24 24">
                                        <path d="M20 6L9 17l-5-5"></path>
                                    </svg>
                                </span>
                            ) : (
                                <span className="w-4 h-4 mr-2 inline-flex items-center justify-center bg-primary-50 text-white rounded-full flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-3 h-3" viewBox="0 0 24 24">
                                        <path d="M20 6L9 17l-5-5"></path>
                                    </svg>
                                </span>
                            )}
                            <div className="text-xl">
                                {feature}
                            </div>

                        </div>
                    )}
                    {props.color ? (
                        <button onClick={handleTerminalPicked} style = {{backgroundColor: props.color}} className={`flex items-center mt-auto text-white border-0 py-2 px-4 w-full focus:outline-none hover:bg-pimary-100 rounded`}>{props.buttonTxt}
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </button>
                    ) : (
                        <button onClick={handleTerminalPicked} className="flex items-center mt-auto text-white bg-primary-50 border-0 py-2 px-4 w-full focus:outline-none hover:bg-pimary-100 rounded">{props.buttonTxt}
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </button>
                    )}

                    <div className="text-xs text-gray-500 mt-3">{props.bottomTxt}</div>
                </div>
            }
            {props.popular === true && !props.color &&
                <div className={`h-full p-4 rounded-lg border-2 border-primary-50 flex flex-col relative overflow-hidden`}>
                    <span className={`bg-primary-50 text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl`}>{props.card}</span>
                    <h2 className="text-base tracking-wide title-font mb-1 font-medium">{props.name}</h2>
                    <h1 className="text-4xl text-gray-900 font-bold pb-4 mb-4 border-b border-gray-200 leading-none"><span className="line-through">{props.cost}</span><span className="no-line-through"> FREE</span></h1>
                    <img className="border-b border-gray-200" src={props.image} />
                    {props.features.map((feature) =>
                        <div className="flex items-center text-gray-600 mb-5">
                            {props.color ? (
                                <span className={`w-4 h-4 mr-2 inline-flex items-center justify-center bg-${props.color}-primary text-white rounded-full flex-shrink-0`}>
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-3 h-3" viewBox="0 0 24 24">
                                        <path d="M20 6L9 17l-5-5"></path>
                                    </svg>
                                </span>
                            ) : (
                                <span className="w-4 h-4 mr-2 inline-flex items-center justify-center bg-primary-50 text-white rounded-full flex-shrink-0">
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" className="w-3 h-3" viewBox="0 0 24 24">
                                        <path d="M20 6L9 17l-5-5"></path>
                                    </svg>
                                </span>
                            )}
                            <div className="text-xl">
                                {feature}
                            </div>

                        </div>
                    )}
                    {props.color ? (
                        <button onClick={handleTerminalPicked} className={`flex items-center mt-auto text-white bg-${props.color}-primary border-0 py-2 px-4 w-full focus:outline-none hover:bg-pimary-100 rounded`}>{props.buttonTxt}
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </button>
                    ) : (
                        <button onClick={handleTerminalPicked} className="flex items-center mt-auto text-white bg-primary-50 border-0 py-2 px-4 w-full focus:outline-none hover:bg-pimary-100 rounded">{props.buttonTxt}
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-4 h-4 ml-auto" viewBox="0 0 24 24">
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </button>
                    )}

                    <div className="text-xs text-gray-500 mt-3">{props.bottomTxt}</div>
                </div>
            }
            {/* <span className="bg-indigo-500 text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl">{props.card}</span> */}
        </div>
    )
}